import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "chart.js/auto";
// import { BrowserRouter } from "react-router-dom";
import { HashRouter } from "react-router-dom";
import { AuthProvider } from "layouts/authentication/AuthContext"; // Import AuthProvider
import App from "App";
// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from "context";

const root = createRoot(document.getElementById("root"));

root.render(
  <StrictMode>
    <HashRouter>
      <MaterialUIControllerProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </MaterialUIControllerProvider>
    </HashRouter>
  </StrictMode>
);
